<template>
  <v-app>
    <v-main>
      <div class="kyano-card-hero-banner">
        <img src="../assets/card-profile-default-banner.png" />
      </div>

      <div class="kyano-card-main-content">
        <div class="kyano-card-main-content-container">
          <div class="kyano-card-profile-img">
            <img src="../assets/profielfoto-linkedin.png" alt="" />
          </div>
          <h2 class="text-primary text-center">
            {{ firstname }} {{ lastname }}
          </h2>
          <p class="text-center">{{ functiontitle }}</p>
          <br />
          <v-row>
            <v-col cols="6" sm="6">
              <v-bottom-sheet
                class="rounded-t-xl elevation-0"
                v-model="sharesheet"
                inset
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    elevation="0"
                    block
                    large
                    color="bg_light"
                    class=""
                  >
                    <v-icon
                      class="mr-2"
                      color="primary"
                      v-text="'fal fa-share-alt'"
                    ></v-icon>

                    Delen</v-btn
                  >
                </template>

                <v-sheet
                  class="text-center rounded-t-xl elevation-0 pa-3"
                  height="400px"
                >
                </v-sheet>
              </v-bottom-sheet>
            </v-col>
            <v-col cols="6" sm="6">
              <v-btn elevation="0" block large color="secondary" @click="save">
                <v-icon class="mr-2" v-text="'fal fa-download'"></v-icon>
                Opslaan</v-btn
              >
            </v-col>
          </v-row>
          <br />
          <br />
          <h3 class="text-primary mb-3">Mijn gegevens</h3>
          <v-card elevation="0" outlined class="border rounded-lg mb-5">
            <v-list dense class="py-0">
              <template v-for="(item, index) in personalitems">
                <v-divider inset v-if="item.divider" :key="index"></v-divider>
                <v-list-item
                  v-else
                  :key="item.title"
                  :href="item.href"
                  class="py-1"
                >
                  <v-list-item-icon>
                    <v-icon
                      class="text-primary text-center mx-auto"
                      color="primary"
                      v-text="item.icon"
                    ></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      class="kyano-font-size-17"
                      v-html="item.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                  <v-icon class="font-size-small text-systemgrey5"
                    >fal fa-chevron-right</v-icon
                  >
                </v-list-item>
              </template>
            </v-list>
          </v-card>
          <br />
          <h3 class="text-primary mb-3">Bedrijfsgegevens</h3>
          <v-card elevation="0" outlined class="border rounded-lg mb-5">
            <v-list dense class="py-0">
              <template v-for="(item, index) in organisationitems">
                <v-divider inset v-if="item.divider" :key="index"></v-divider>
                <v-list-item
                  v-else
                  :key="item.title"
                  :href="item.href"
                  class="py-1"
                >
                  <v-list-item-icon>
                    <v-icon
                      class="text-primary text-center mx-auto"
                      color="primary"
                      v-text="item.icon"
                    ></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      class="kyano-font-size-17"
                      v-html="item.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                  <v-icon class="font-size-small text-systemgrey5"
                    >fal fa-chevron-right</v-icon
                  >
                </v-list-item>
              </template>
            </v-list>
          </v-card>
          <br />
          <h3 class="text-primary mb-3">Collega's</h3>
          <v-sheet class="mx-auto" elevation="0">
            <v-slide-group class="py-4" active-class="success">
              <v-slide-item
                v-for="(data, datai) in datacolleagues"
                :key="datai"
              >
                <ColleagueDialog :data="data" />
              </v-slide-item>
            </v-slide-group>
          </v-sheet>

          <v-btn elevation="0" block large color="secondary" @click="save">
            <v-icon class="mr-2" v-text="'fal fa-download'"></v-icon>
            Opslaan</v-btn
          >
        </div>
      </div>
      <!-- Main content -->
    </v-main>
  </v-app>
</template>
<script>
import ColleagueDialog from "@/components/cardprofile/ColleagueDialog.vue";
import * as vCardsJS from "vcards-js";

export default {
  components: { ColleagueDialog },
  props: {},

  data: () => ({
    sharesheet: false,

    firstname: "Gianni",
    middlename: "",
    lastname: "Hesseling",
    functiontitle: "Developer",
    organisation: "Snelwebcenter",
    workphone: "0612345678",

    datacolleagues: [
      {
        id: 1,
        name: "Stan van der Weide",
        function: "Sales",
        sheet: false,
      },
      {
        id: 2,
        name: "Jesper",
        function: "dev",
        sheet: false,
      },
      {
        id: 1,
        name: "Stan van der Weide",
        function: "Sales",
        sheet: false,
      },
      {
        id: 2,
        name: "Jesper",
        function: "dev",
        sheet: false,
      },
    ],

    personalitems: [
      {
        icon: "fal fa-mobile-alt",
        title: "0615234393",
        href: "tel:003112345678",
      },
      { divider: true, inset: false },

      {
        icon: "fal fa-envelope",
        title: "Gianni@snelwebcenter.nl",
        href: "mailto:gianni@snelwebcenter.nl",
      },
      { divider: true, inset: false },
      {
        icon: "fal fa-map-marker-alt",
        title: "Moermanskweg 2-22",
        href: "",
      },
    ],

    organisationitems: [
      {
        icon: "fal fa-mobile-alt",
        title: "0850160922",
        href: "tel:0850160922",
      },
      { divider: true, inset: false },
      {
        icon: "fal fa-envelope",
        title: "info@snelwebcenter.nl",
        href: "mailto:info@snelwebcenter.nl",
      },
      { divider: true, inset: false },
      {
        icon: "fal fa-globe",
        title: "www.snelwebcenter.nl",
        href: "https://www.snelwebcenter.nl",
      },
      { divider: true, inset: false },
      {
        icon: "fal fa-map-marker-alt",
        title: "Moermanskweg 2-22",
        href: "",
      },
    ],
  }),

  methods: {
    save() {
      let vCard = new vCardsJS();

      vCard.firstName = this.firstname;
      vCard.middleName = this.middlename;
      vCard.lastName = this.lastname;
      vCard.organization = this.organisation;
      vCard.photo.attachFromUrl(
        "https://avatars2.githubusercontent.com/u/5659221?v=3&s=460",
        "JPEG"
      );
      vCard.workPhone = this.workphone;
      vCard.birthday = new Date(1985, 0, 1);
      vCard.title = this.functiontitle;
      vCard.url = "https://github.com/enesser";
      vCard.note = "Notes on Eric";

      //get as formatted string
      let elm = document.createElement("a");
      elm.setAttribute(
        "href",
        "data:text/vcard;charset=utf-8," +
          encodeURIComponent(vCard.getFormattedString())
      );
      elm.setAttribute("download", "kyano-businesscard.vcf");
      elm.style.display = "none";
      document.body.appendChild(elm);
      elm.click();
      document.body.removeChild(elm);
    },
  },
};
</script>

<style>
.kyano-card-main-content {
  background: #fff;
  border-radius: 20px 20px 0px 0px;
  min-height: 100vh;
  padding: 20px;
}

.kyano-font-size-17 {
  font-size: 17px !important;
}

.kyano-card-hero-banner {
  position: fixed;
  width: 100%;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 300px;
  background: #1c1c1e;
}

.kyano-card-main-content {
  top: 280px;
  position: relative;
}

.kyano-card-main-content-container {
  max-width: 500px;
  margin: 0 auto;
}
.kyano-card-hero-banner img {
  object-fit: cover;
  height: 300px;
  width: 100%;
}

.kyano-card-profile-img {
  text-align: center;
}

.kyano-card-profile-img img {
  position: relative;
  margin-top: -100px;
  border-radius: 200px;
  width: 150px;
  height: 150px;
  overflow: hidden;
}

@media (max-width: 768px) {
  .kyano-card-main-content {
    top: 180px;
  }
  .kyano-card-hero-banner {
    height: 200px;
  }

  .kyano-card-hero-banner img {
    height: 200px;
  }
}
</style>
